module.exports = __webpack_public_path__ + "static/img/help_06intro_41.792a0d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_06intro_41.png
// module id = 732
// module chunks = 140